import $api from "../http";
import {
  EmailTemplateLanguageType,
  EmailTemplateSubjectEnum,
  ICreateOrUpdateEmailTemplate,
  IEmailTemplate,
  IEmailTemplateForTable,
  IEmailTemplateSubject,
  IEmailTemplateVersion,
} from "../models/EmailTemplate";

class EmailTemplateServiceClass {
  async getEmailTemplateVersionByLanguage(
    emailTemplateId: string,
    language: EmailTemplateLanguageType
  ) {
    return $api.get<IEmailTemplateVersion>(
      `api/email-template/version/${emailTemplateId}?language=${language}`
    );
  }

  async getEmailTemplateSubjects() {
    return $api.get<IEmailTemplateSubject[]>(`api/email-template/subjects`);
  }

  async getEmailTemplateById(id: string) {
    return $api.get<IEmailTemplate>(`api/email-template/${id}`);
  }

  // With a subject - only the constants its email replaces
  async getEmailTemplateConstants(subject?: string) {
    return $api.get<string[]>(`api/email-template/constants`, { params: { subject } });
  }

  // An image for the email builder, stored in DigitalOcean Spaces
  async uploadEmailImage(file: File) {
    const formData = new FormData();
    formData.append("file", file);
    return $api.post<{ url: string }>(`api/email-template/images/upload`, formData);
  }

  // The content inside the header / footer of the language, as it is sent
  async previewEmailTemplate(content: string, language: EmailTemplateLanguageType) {
    return $api.post<{ html: string }>(`api/email-template/preview`, { content, language });
  }

  async createOrUpdateEmailTemplate(model: ICreateOrUpdateEmailTemplate) {
    return $api.post<{}>(`api/email-template`, model);
  }

  async getAllEmailTemplates(currentPage: number | undefined, pageSize: number | undefined) {
    let queryString = `currentPage=${currentPage}&pageSize=${pageSize}`;
    return $api.get<{ items: IEmailTemplateForTable[]; total: number }>(
      `api/email-template?${queryString}`
    );
  }

  async deleteEmailTemplate(id: string) {
    return $api.delete<{}>(`api/email-template/${id}`);
  }

  async testSendEmailTemplate(
    to: string,
    language: EmailTemplateLanguageType,
    subject: EmailTemplateSubjectEnum
  ) {
    return $api.post<boolean>(`api/email-template/test/send-${subject}-email`, {
      to,
      language,
    });
  }
}

export const EmailTemplateService = new EmailTemplateServiceClass();
